import { useState, useEffect } from "react";
import "./subscription.css";
import axiosInstance from "../../axios";
import Button from "../../components/button";

const Subscription = () => {
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userId] = useState(JSON.parse(localStorage.getItem("userDetails"))?.userId);
  const [userDetails, setUserDetails] = useState({});
  const [paymentPopUp, setPaymentPopUp] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [planAmt, setPlanAmt] = useState(1000);

  useEffect(() => {
    fetchSubscriptionData();
    getUserDashboardDetails();
  }, []);

  const getUserDashboardDetails = () => {
    try {
      axiosInstance
        .get(`v1/student/dashboard`)
        .then(data => {
          const response = data.data;
          const userData = {
            profilePic: response.profile_pic,
            Name: response.user_name,
            userId: response.id,
            isAuthenticated: response.isAuthenticated,
          };
          userData.specialRequest = response.requests_data?.find(x => x.category_id === 13);

          if (userData.specialRequest) {
            setPlanAmt(2000);
          } else {
            setPlanAmt(1000);
          }

          localStorage.setItem("userDetails", JSON.stringify(userData));
          setUserDetails(userData);
          if (
            JSON.parse(localStorage.getItem("paymentPopUp")) &&
            !response.requests_data?.find(deal => deal.advance_payment > 0)
          )
            setPaymentPopUp(response.requests_data[0]?.advance_amount);
          setLoading(false);
        })
        .catch(err => {});
    } catch (error) {}

    // To ensure localStorage is updated with the latest userId, fetch it fresh after setUserDetails
    let latestUserDetails = null;
    try {
      latestUserDetails = JSON.parse(localStorage.getItem("userDetails"));
    } catch (e) {
      latestUserDetails = null;
    }
    if (latestUserDetails && latestUserDetails.userId) {
      axiosInstance
        .get(`v1/student/subscription-status?student_id=${latestUserDetails.userId}`)
        .then(data => {
          const response = data.data.data;
          // Update localStorage with the latest userDetails and isAuthenticated status
          localStorage.removeItem("userDetails");
          const updatedUserDetails = { ...latestUserDetails, isAuthenticated: response.status === "Subscribed" };

          localStorage.setItem("userDetails", JSON.stringify(updatedUserDetails));
        })
        .catch(err => {});
    }
  };

  const fetchSubscriptionData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/v1/student/subscription-history?userId=${userId}&page=1&limit=1000`);
      const today = new Date();
      const result = response?.data?.data?.result || [];

      const activePlan = result[0];

      const currentPlan = activePlan
        ? {
            name: "HomeShiksha Preferred Customer Plan",
            status: activePlan.status,
            subscribedOn: activePlan.start_date,
            duration: activePlan.plan_validity_in_months + " months ",
            price: "₹" + activePlan.amount + "/-",
            expiresOn: activePlan.end_date,
          }
        : null;

      if (activePlan.status !== "ACTIVE") {
        setSubscriptionData({
          currentPlan: null,
          pastSubscriptions: result,
        });
      } else {
        setSubscriptionData({
          currentPlan,
          pastSubscriptions: result.filter(plan => plan !== activePlan),
        });
      }
    } catch (error) {
      console.error("Error fetching subscription data:", error);
      setSubscriptionData({
        currentPlan: null,
        pastSubscriptions: [],
      });
    } finally {
      setLoading(false);
    }
  };

  const buySubscription = async planId => {
    setIsLoading(true);
    try {
      // Step 1: Create order from backend
      const {
        data: { data: order },
      } = await axiosInstance.post("v1/student/create-order", {
        planType: planAmt === 1000 ? "Basic" : "Special",
        isStudent: true,
      });

      const user = JSON.parse(localStorage.getItem("userDetails"));

      // Step 2: Configure Razorpay
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: order.currency,
        name: "HomeShiksha",
        description: "HomeHomeShikshash Plan",
        order_id: order.id,
        callback_url: `${process.env.REACT_APP_DOMAIN_NAME}v1/tutor/order-payment-verification?userId=${
          user.userId
        }&planType=${planAmt === 1000 ? "Basic" : "Special"}&isStudent=true`, // ✅ backend URL
        // prefill: {
        //   name: "HomeShiksha",
        //   email: "homeshiksha@gmail.com",
        //   contact: "9876543210",
        // },
        theme: {
          color: "#2B93A5",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      setLoading(false);
      console.error("Payment Error:", error);
    }
    // try {
    //   const payload = {
    //     planId: planAmt === 2000 ? "plan_ROZ1UKuvncyeXV" : "plan_RNnGWybdWJBpfx",
    //     userId: JSON.parse(localStorage.getItem("userDetails"))?.userId,
    //   };
    //   const { data } = await axios.post(`v1/plans`, payload);
    //   setSubscriptionId(data?.subscriptionId);
    //   setIsLoading(false);
    // } catch (error) {
    //   setIsLoading(false);
    //   console.error(error);
    // }
  };
  const hidepopUP = () => {
    localStorage.setItem("paymentPopUp", JSON.stringify(false));
    setPaymentPopUp(0);
  };

  useEffect(() => {
    if (subscriptionId) {
      const openPopUp = () => {
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          name: "HomeShiksha",
          description: "Access to HomeShiksha",
          image: "./profile.jpg",
          subscription_id: subscriptionId,
          callback_url: `${process.env.REACT_APP_DOMAIN_NAME}v1/subscriptions`,
          prefill: {
            name: "HomeShiksha",
            email: "homeshiksha@gmail.com",
            contact: "9876543210",
          },
          notes: {
            address: "HomeShiksha",
          },
          theme: {
            color: "#212333",
          },
        };

        const razor = new window.Razorpay(options);
        razor.open();
      };
      openPopUp();
    }
  }, [subscriptionId, userId]);

  return loading ? (
    <div className="subscription-loading">
      <div className="loading">
        <img src="/book-loader.gif" alt="Loading..." />
      </div>
    </div>
  ) : (
    <div className="subscription-page">
      {paymentPopUp !== 0 && (
        <div className="dashboard-payment-popup">
          <div className="tutor-popup-wrapper--content-screen" style={{ zIndex: 81 }}>
            <div
              style={{ textAlign: "end", margin: "3px 8px", cursor: "pointer" }}
              onClick={() => {
                hidepopUP();
              }}>
              Close
            </div>
            <div className="payment-pending--wrapper">
              <div className="payment-pending--title">Upgrade to HOMESHIKSHA PREFERRED CUSTOMER</div>
              <div className="payment-pending--description">
                *We get over 500 requirements for tutors daily. Sometimes its not possible for us to arrange tutors for
                everyone. If you genuinely have a requirement for a tutor, then pay this small 'refundable' fee of Rs.
                {planAmt} and your requirement will be given first priority.
              </div>
              <div
                className="payment-pending--paynow-btn"
                onClick={() => {
                  buySubscription("plan_RNnGWybdWJBpfx");
                }}>
                <Button>{isLoading ? "Loading..." : "Pay Now"}</Button>
              </div>
              <div className="payment-pending--payment-amount">Advance Payment {planAmt}/-</div>
            </div>
            <div className="pending--process-wrapper">
              <div className="pending--process--title payment-pending--description">Process : </div>
              <div className="pending--process--steps--wrapper">
                <ol>
                  <li>Dedicated Customer Relationship manager will be assigned to handle your requirement.</li>
                  <li>
                    You will become our subscribed customer for {userDetails.specialRequest ? "12" : "6"} months. You
                    will can avail free tutor replacements and have the option to request an unlimited number of tutors
                    during this period.
                  </li>
                </ol>
              </div>
              <div className="pending--payment--TC">
                ★ This amount is fully refundable in case we are not able to Provide you the tutor as per your need ★
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="subscription-content">
        <div className="subscription-section">
          <h2 className="subscription-section-title">
            Current Subscription Plan :{" "}
            {!subscriptionData?.currentPlan && (
              <>
                <span className="subscription-section-title-text">
                  You not subscribed to HomeShiksha Preferred Customer
                </span>
                <span
                  onClick={() => {
                    setPaymentPopUp(1);
                    // payNow();
                    // logEvent(EVENTS.PAY_NOW_BUTTON.event_name);
                  }}
                  className="subscribe-link">
                  {" "}
                  Subscribe now
                </span>
              </>
            )}
          </h2>

          {subscriptionData?.currentPlan && (
            <div className="subscription-card active-subscription">
              <div className="subscription-header">
                <h3 className="plan-name">{subscriptionData.currentPlan.name}</h3>
                <span className="status-badge active">{subscriptionData.currentPlan.status}</span>
              </div>

              <div className="subscription-details">
                <p className="detail-text">Subscribed on: {subscriptionData.currentPlan.subscribedOn}</p>
                <p className="detail-text">
                  {subscriptionData.currentPlan.duration}: {subscriptionData.currentPlan.price}
                </p>
                <p className="detail-text expires">
                  <strong>Expires on : </strong>
                  {subscriptionData.currentPlan.expiresOn}
                </p>
              </div>
            </div>
          )}
        </div>
        <div className="subscription-section">
          <h2 className="subscription-section-title">
            Past Subscriptions :{" "}
            {!subscriptionData?.pastSubscriptions ||
              (subscriptionData?.pastSubscriptions.length === 0 && (
                <span className="subscription-section-title-text">You don't have any past subscriptions</span>
              ))}
          </h2>

          <div className="past-subscriptions">
            {subscriptionData?.pastSubscriptions.map(
              (subscription, index) =>
                subscription.status !== "ACTIVE" && (
                  <div key={index} className="subscription-card past-subscription">
                    <div className="subscription-header">
                      <h3 className="plan-name expired">{"HomeShiksha Preferred Customer Plan"}</h3>
                      <span className="status-badge expired">{subscription.status}</span>
                    </div>

                    <div className="subscription-details">
                      <p className="detail-text">Subscribed on: {subscription.start_date}</p>
                      <p className="detail-text">
                        {subscription.plan_validity_in_months + " months "}: {"₹" + subscription.amount + "/-"}
                      </p>
                      <p className="detail-text expires">
                        <strong>Expired on : </strong> {subscription.end_date}
                      </p>
                    </div>
                  </div>
                ),
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
